/* raw layout hash: _spatial-hierarchy-property-tree-layout:a6e8bac507db8885ba1cdcf24e5b1c6fc6d06a8f501742b18f1e1d3094cff404 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_spatial-hierarchy-property-tree-layout" — renders its page content through the router outlet.
export default function SpatialHierarchyPropertyTreeLayout() {
  return <AppShell layoutName="_spatial-hierarchy-property-tree-layout" menu={LAYOUT_MENUS['_spatial-hierarchy-property-tree-layout']} />;
}
